import Link from "next/link";

import { Anchor, Button, Logo } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import withTrackEvent from "@/eventStream/withTrackEvent";
import { MONOLITH_ROOT } from "@/monolithIntegration/monolithIntegration.constants";
import { useSignOut } from "@/users/useUser";
import {
  containerCss,
  logoCss,
  logoLinkCss,
  rightButtonCss,
} from "./UtilityNavContents.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);
const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  onBack: PropTypes.func,
  disableBack: PropTypes.bool,
  disableSignOut: PropTypes.bool,
};

const UtilityNavContents = ({ onBack, disableBack, disableSignOut }) => {
  const router = useRouter();
  const signOut = useSignOut();

  const onSignOut = async () => {
    await signOut();
  };

  return (
    <div css={containerCss}>
      {!disableBack && (
        <ButtonWithTrackEvent
          flavor={Button.flavors.tertiary}
          size={Button.sizes.sm}
          onClick={() => (onBack ? onBack() : router.back())}
          objectType="User"
          actionName="Navigate"
          streamProperties={{
            description: "Navigate to previous page",
          }}
        >
          Back
        </ButtonWithTrackEvent>
      )}
      <Link href={MONOLITH_ROOT} passHref legacyBehavior>
        <AnchorWithTrackEvent
          ariaProps={{
            "aria-label": "Newsela Home",
          }}
          __cssFor={logoLinkCss}
          objectType="User"
          actionName="Navigate"
          streamProperties={{
            description: "Navigate to home page",
          }}
        >
          <Logo __cssFor={logoCss} __overrideFullWidth={131} />
        </AnchorWithTrackEvent>
      </Link>
      {!disableSignOut && (
        <ButtonWithTrackEvent
          flavor={Button.flavors.tertiary}
          size={Button.sizes.sm}
          onClick={onSignOut}
          __cssFor={rightButtonCss}
          objectType="User"
          actionName="Sign Out"
          streamProperties={{
            description: "Sign out",
          }}
        >
          Sign out
        </ButtonWithTrackEvent>
      )}
    </div>
  );
};

UtilityNavContents.propTypes = propTypes;

export default UtilityNavContents;
